import moment from 'moment';
import { utilsModule } from '../utils-module';
/**
 * armazena os filtros informados para produtos de venda
 */
utilsModule.service('ordersFilters', ['OrderTypeService',function (OrderTypeService) {
    /**
     * ALL (1), ONLY_CLIENT_BLOCK (2)
     */
    this.block = undefined;
    /**
     * indica se a busca de preços dos produtos será feita olhando o grupo padrão
     * ou o grupo do cliente em questão
     */
    this.onlyDefaultClientGroup = false;
    this.listAllProducts = false;
    /**
     *
     * @type {string} CURRENT_DATE, SPECIFIC_DATE, PERIOD
     */
    this.searchByDateSelectedOption = 'SPECIFIC_DATE';
    this.specificDate = moment().startOf('day').toDate();
    this.dateInitial = new Date();
    this.dateFinal = new Date();
    this.shoppingFilters = {};
    this.shoppingFilters.pending = true;
    this.shoppingFilters.completed = false;

    this.orderTypes = [OrderTypeService.ORDER_TYPE_SALES,
    OrderTypeService.ORDER_TYPE_PURCHASE,
    OrderTypeService.ORDER_TYPE_STOCK,
    OrderTypeService.ORDER_TYPE_BUDGET,
    OrderTypeService.ORDER_TYPE_BUDGET_ADD];

    this.observation = {
        with: true,
        without: true
    };
}]);
